import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef154fce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section comments" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Tenant Comments", -1))
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1))
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1))
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Tenant", -1))
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = {
  key: 0,
  class: "feedback-half-section jumbotron selected-item-jumbotron"
}
const _hoisted_18 = { class: "table" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"10%"},
  class: "align-middle"
}, " Ref ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"20%"},
  class: "align-middle"
}, " Room ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"25%"},
  class: "align-middle"
}, " Description ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"25%"},
  class: "align-middle"
}, " PI Comments ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"30%"},
  class: "align-middle"
}, " Tenant Comments ", -1))
const _hoisted_24 = {
  scope: "col",
  style: {"width":"5%"},
  class: "align-middle"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  scope: "col",
  style: {"width":"5%"},
  class: "align-middle"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { scope: "row" }
const _hoisted_31 = { class: "table table-sm table-borderless" }
const _hoisted_32 = { style: {"padding":"0px"} }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { colspan: "6" }
const _hoisted_40 = { class: "form-group row" }
const _hoisted_41 = { class: "col-sm-12" }
const _hoisted_42 = { class: "table table-sm table-borderless" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Landlord Comments", -1))
const _hoisted_44 = { class: "form-group row" }
const _hoisted_45 = { class: "col-sm-6" }
const _hoisted_46 = { class: "form-group row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1))
const _hoisted_48 = { class: "col-sm-6" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "form-group row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1))
const _hoisted_52 = { class: "col-sm-6" }
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "form-group row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Client/Landlord", -1))
const _hoisted_56 = { class: "col-sm-9" }
const _hoisted_57 = { class: "col-sm-6" }
const _hoisted_58 = {
  key: 0,
  class: "feedback-half-section jumbotron selected-item-jumbotron"
}
const _hoisted_59 = { class: "table" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"10%"},
  class: "align-middle"
}, " Ref ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"20%"},
  class: "align-middle"
}, " Room ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"25%"},
  class: "align-middle"
}, " Description ", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"25%"},
  class: "align-middle"
}, " PI Comments ", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"width":"30%"},
  class: "align-middle"
}, " Landlord Comments ", -1))
const _hoisted_65 = {
  scope: "col",
  style: {"width":"5%"},
  class: "align-middle"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  scope: "col",
  style: {"width":"5%"},
  class: "align-middle"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { scope: "row" }
const _hoisted_72 = { class: "table table-sm table-borderless" }
const _hoisted_73 = { style: {"padding":"0px"} }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = { colspan: "6" }
const _hoisted_81 = { class: "form-group row" }
const _hoisted_82 = { class: "col-sm-12" }
const _hoisted_83 = { class: "table table-sm table-borderless" }

import { computed, ref, inject, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import _get from "lodash/get";
import moment from "moment";
import { Report, Item, OrderedItem, ShareholderComments, Note } from "@/models";

import ContentEditable from "@/components/ContentEditable.vue";
import Photos from "@/components/photo/Photos.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Comments',
  setup(__props) {

const instance = getCurrentInstance();

// Components
const store = useStore();

const statereport = computed<Report>(() => store.getters['reports/current']);

const setReportDeep = (payload: { path: string; data: any }): Promise<void>  => {
  return store.dispatch('reports/setReportDeep', payload);
};

const actProperty: any = inject('actProperty');

// Computed properties and getters/setters
const tenant = computed({
  get: () => statereport.value.comments.tenant,
  set: (data) => {
    data = data.trim();
    setReportDeep({ path: "comments.tenant", data });
  }
});

const tenantPhotos = computed({
  get: () => statereport.value.comments.tenantPhotos,
  set: (data) => setReportDeep({ path: "comments.tenantPhotos", data })
});

const client = computed({
  get: () => statereport.value.comments.client,
  set: (data) => {
    data = data.trim();
    setReportDeep({ path: "comments.client", data });
  }
});

// clientPhotos computed property
const clientPhotos = computed({
  get: () => statereport.value.comments.clientPhotos,
  set: (data) => {
    setReportDeep({ path: "comments.clientPhotos", data });
  }
});

// propertyInspector computed property
const propertyInspector = computed({
  get: () => statereport.value.comments.propertyInspector,
  set: (data) => {
    setReportDeep({ path: "comments.propertyInspector", data });
  }
});

// commentedItemsByTenant computed property
const commentedItemsByTenant = computed(() => getCommentedItems("Tenant"));

// commentedItemsByLandlord computed property
const commentedItemsByLandlord = computed(() => getCommentedItems("Landlord"));

// allttcommentsapproved computed property
const allttcommentsapproved = computed(() => {
  let approved = true;
  commentedItemsByTenant.value.forEach((item) => {
    if (!item.tenantcomments.approved) {
      approved = false;
    }
  });
  return approved;
});

// allttcommentsflagged computed property
const allttcommentsflagged = computed(() => {
  let flagged = true;
  commentedItemsByTenant.value.forEach((item) => {
    if (!item.tenantcomments.flagged) {
      flagged = false;
    }
  });
  return flagged;
});

const getConditionInNotes = (item: Item) => {
  const notes = _get(item, "condition.in.notes", false);
  if (notes === false) {
    return [];
  }
  return notes;
}

// allllcommentsapproved computed property
const allllcommentsapproved = computed(() => {
  let approved = true;
  commentedItemsByLandlord.value.forEach((item) => {
    if (!item.landlordcomments.approved) {
      approved = false;
    }
  });
  return approved;
});

// allllcommentsflagged computed property
const allllcommentsflagged = computed(() => {
  let flagged = true;
  commentedItemsByLandlord.value.forEach((item) => {
    if (!item.landlordcomments.flagged) {
      flagged = false;
    }
  });
  return flagged;
});

const getCommentedItems = (shareholdertype: string): OrderedItem[] => {
  let items: OrderedItem[] = [];

  if (statereport.value && statereport.value.rooms) {
    statereport.value.rooms.forEach((room, roomindex) => {
      if (room.sections) {
        room.sections.forEach((section, sectionindex) => {
          if (section.types) {
            section.types.forEach((type, typeindex) => {
              if (type.items) {
                type.items.forEach((item, itemindex) => {
                  let orderedItem = new OrderedItem(item);
                  orderedItem.roomname = room.name;
                  orderedItem.roomindex = roomindex;
                  orderedItem.section = section.name;
                  orderedItem.sectionindex = sectionindex;
                  orderedItem.type = type.name;
                  orderedItem.typeindex = typeindex;
                  orderedItem.item = item;
                  orderedItem.itemindex = itemindex;
                  items.push(orderedItem);
                });
              }
            });
          }
        });
      }
    });
  }

  let commentedItems: OrderedItem[] = [];
  items.forEach((orderedItem, index) => {
    orderedItem.order = index + 1;
    let comments = null;
    if (shareholdertype == "Landlord")
      comments = orderedItem.landlordcomments;
    else if (shareholdertype == "Tenant")
      comments = orderedItem.tenantcomments;
    if (
      comments &&
      (comments.comments || (comments.photos && comments.photos.length))
    ) {
      commentedItems.push(orderedItem);
    }
  });

  return commentedItems;
}

/**
 * Returns Active Item Path
 */
const getCommentsPhotoPath = (shareholdertype: string, item: OrderedItem) => {
  let path = "";
  if (shareholdertype == "Landlord")
    path = `rooms[${item.roomindex}].sections[${item.sectionindex}].types[${item.typeindex}].items[${item.itemindex}].landlordcomments.photos`;
  else if (shareholdertype == "Tenant")
    path = `rooms[${item.roomindex}].sections[${item.sectionindex}].types[${item.typeindex}].items[${item.itemindex}].tenantcomments.photos`;
  return path;
}

/**
 * Return Check-In Photos from Items
 *
 * @param {Item} item
 */
const getCommentsPhotos = (shareholdertype: string, item: Item) => {
  let photos = [];
  if (shareholdertype == "Landlord")
    photos = _get(item, "landlordcomments.photos", []);
  else if (shareholdertype == "Tenant")
    photos = _get(item, "tenantcomments.photos", []);
  return photos;
}

const getCommentsPhotosLength = (shareholdertype: string, item: Item) => {
  let arr = getCommentsPhotos(shareholdertype, item);
  return arr.length;
};

const toggleAllCommentsApproved = (shareholdertype: string) => {
  let items: OrderedItem[] = [];
  let allapproved = false;
  if (shareholdertype == "Landlord") {
    items = commentedItemsByLandlord.value;
    allapproved = allllcommentsapproved.value;
  } else if (shareholdertype == "Tenant") {
    items = commentedItemsByTenant.value;
    allapproved = allttcommentsapproved.value;
  }

  if (items.length) {
    items.forEach((item) => {
      if (allapproved) unapproveComment(shareholdertype, item);
      else approveComment(shareholdertype, item);
    });
  }
}

const approveComment = (shareholdertype: string, item: OrderedItem) => {
  if (
    (shareholdertype == "Tenant" &&
      item.tenantcomments &&
      !item.tenantcomments.approved) ||
    (shareholdertype == "Landlord" &&
      item.landlordcomments &&
      !item.landlordcomments.approved)
  ) {
    toggleCommentsApproved(shareholdertype, item);
  }
}

const unapproveComment = (shareholdertype: string, item: OrderedItem) => {
  if (
    (shareholdertype == "Tenant" &&
      item.tenantcomments &&
      item.tenantcomments.approved) ||
    (shareholdertype == "Landlord" &&
      item.landlordcomments &&
      item.landlordcomments.approved)
  ) {
    toggleCommentsApproved(shareholdertype, item);
  }
}

const toggleCommentsApproved = (
  shareholdertype: string,
  item: OrderedItem
): void => {
  let approved = false;
  if (shareholdertype == "Tenant" && item.tenantcomments) {
    item.tenantcomments.approved = !item.tenantcomments.approved;
    approved = item.tenantcomments.approved;
    setReportDeep({
      path: getItemPath(item, `tenantcomments.approved`),
      data: item.tenantcomments.approved,
    }).then(() => instance?.proxy?.$forceUpdate());
  } else if (shareholdertype == "Landlord" && item.landlordcomments) {
    item.landlordcomments.approved = !item.landlordcomments.approved;
    approved = item.landlordcomments.approved;
    setReportDeep({
      path: getItemPath(item, `landlordcomments.approved`),
      data: item.landlordcomments.approved,
    }).then(() => instance?.proxy?.$forceUpdate());
  }
}

const toggleAllCommentsFlagged = (shareholdertype: string) => {
  let items: OrderedItem[] = [];
  let allflagged = false;
  if (shareholdertype == "Landlord") {
    items = commentedItemsByLandlord.value;
    allflagged = allllcommentsflagged.value;
  } else if (shareholdertype == "Tenant") {
    items = commentedItemsByTenant.value;
    allflagged = allttcommentsflagged.value;
  }

  if (items.length) {
    items.forEach((item) => {
      if (allflagged) unflagComment(shareholdertype, item);
      else flagComment(shareholdertype, item);
    });
  }
}

const flagComment = (shareholdertype: string, item: OrderedItem) => {
  if (
    (shareholdertype == "Tenant" &&
      item.tenantcomments &&
      !item.tenantcomments.flagged) ||
    (shareholdertype == "Landlord" &&
      item.landlordcomments &&
      !item.landlordcomments.flagged)
  ) {
    toggleCommentsFlagged(shareholdertype, item);
  }
}

const unflagComment = (shareholdertype: string, item: OrderedItem) => {
  if (
    (shareholdertype == "Tenant" &&
      item.tenantcomments &&
      item.tenantcomments.flagged) ||
    (shareholdertype == "Landlord" &&
      item.landlordcomments &&
      item.landlordcomments.flagged)
  ) {
    toggleCommentsFlagged(shareholdertype, item);
  }
}

const toggleCommentsFlagged = (
  shareholdertype: string,
  item: OrderedItem
): void => {
  let flagged = false;
  if (shareholdertype == "Tenant" && item.tenantcomments) {
    // Do not flag an item that has not yet been approved
    if (!item.tenantcomments.flagged && !item.tenantcomments.approved) {
      actProperty.displayError(
        "Feedback must be approved before it can be flagged"
      );
      return;
    }

    item.tenantcomments.flagged = !item.tenantcomments.flagged;
    flagged = item.tenantcomments.flagged;
    setReportDeep({
      path: getItemPath(item, `tenantcomments.flagged`),
      data: item.tenantcomments.flagged,
    }).then(() => instance?.proxy?.$forceUpdate());
    if (flagged) {
      insertNote(shareholdertype, item.tenantcomments, item);
    } else {
      removeNote(shareholdertype, item.tenantcomments, item);
    }
  } else if (shareholdertype == "Landlord" && item.landlordcomments) {
    // Do not flag an item that has not yet been approved
    if (!item.landlordcomments.flagged && !item.landlordcomments.approved) {
      actProperty.displayError(
        "Feedback must be approved before it can be flagged"
      );
      return;
    }

    item.landlordcomments.flagged = !item.landlordcomments.flagged;
    flagged = item.landlordcomments.flagged;
    setReportDeep({
      path: getItemPath(item, `landlordcomments.flagged`),
      data: item.landlordcomments.flagged,
    }).then(() => instance?.proxy?.$forceUpdate());
    if (flagged) {
      insertNote(shareholdertype, item.landlordcomments, item);
    } else {
      removeNote(shareholdertype, item.landlordcomments, item);
    }
  }
}

const insertNote = (
  shareholdertype: string,
  comment: ShareholderComments,
  item: OrderedItem
) => {
  const notes: Note[] = _get(item, `condition.in.notes`, []);
  let shprefix = "";
  if (shareholdertype == "Tenant") shprefix = "TT";
  else if (shareholdertype == "Landlord") shprefix = "LL";
  const commentdate: any = moment(comment.updatedAt).format("DD/MM/YYYY");
  const note = new Note();
  note.note = `${shprefix} advised on ${commentdate}: ${comment.comments}`;
  notes.push(note);
  setReportDeep({
    path: getItemPath(item, `condition.in.notes`),
    data: notes,
  }).then(() => instance?.proxy?.$forceUpdate());
}

const removeNote = (
  shareholdertype: string,
  comment: ShareholderComments,
  item: OrderedItem
) => {
  const notes: Note[] = _get(item, `condition.in.notes`, []);
  let shprefix = "";
  if (shareholdertype == "Tenant") shprefix = "TT";
  else if (shareholdertype == "Landlord") shprefix = "LL";
  const commentdate: any = moment(comment.updatedAt).format("DD/MM/YYYY");
  let notetodelete = `${shprefix} adviced on ${commentdate}: ${comment.comments}`;

  const found = notes.findIndex((x) => x.note == notetodelete);
  if (found >= 0) {
    notes.splice(found, 1);
  }

  setReportDeep({
    path: getItemPath(item, `condition.in.notes`),
    data: notes,
  }).then(() => instance?.proxy?.$forceUpdate());
}

/**
 * Returns Active Item Path
 */
const getItemPath = (item: OrderedItem, append: string) => {
  if (append) {
    append = `.${append}`;
  }
  return `rooms[${item.roomindex}].sections[${item.sectionindex}].types[${item.typeindex}].items[${item.itemindex}]${append}`;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: statereport.value.tenantcommentsname,
                disabled: ""
              }, null, 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: statereport.value.tenantcommentsemail,
                disabled: ""
              }, null, 8, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "10",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tenant).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  tenant.value,
                  void 0,
                  { lazy: true }
                ]
              ]),
              (_openBlock(), _createBlock(Photos, {
                photos: tenantPhotos.value,
                path: 'comments.tenantPhotos',
                key: `${tenantPhotos.value.length}`
              }, null, 8, ["photos", "path"]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (commentedItemsByTenant.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("table", _hoisted_18, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _createElementVNode("th", _hoisted_24, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleAllCommentsApproved('Tenant'))),
                          class: _normalizeClass(["btn btn-sm btn-outline-info", {
                        approvedcomment: allttcommentsapproved.value,
                      }])
                        }, _hoisted_26, 2)
                      ]),
                      _createElementVNode("th", _hoisted_27, [
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleAllCommentsFlagged('Tenant'))),
                          class: _normalizeClass(["btn btn-sm btn-outline-info text-danger", {
                        flaggedcomment: allttcommentsflagged.value,
                      }])
                        }, _hoisted_29, 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentedItemsByTenant.value, (item) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.uuid
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_30, _toDisplayString(item.order), 1),
                          _createElementVNode("td", null, _toDisplayString(item.roomname), 1),
                          _createElementVNode("td", null, _toDisplayString(item.section) + ":" + _toDisplayString(item.type) + ":" + _toDisplayString(item.name), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("table", _hoisted_31, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConditionInNotes(item), (note) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: note._uuid
                                }, [
                                  _createElementVNode("td", _hoisted_32, _toDisplayString(note.note), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(ContentEditable, {
                              content: item.tenantcomments.comments,
                              multiline: true,
                              onUpdate: ($event: any) => (
                          setReportDeep({
                            path: getItemPath(item, 'tenantcomments.comments'),
                            data: $event,
                          })
                        )
                            }, null, 8, ["content", "onUpdate"])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (toggleCommentsApproved('Tenant', item)),
                              class: _normalizeClass(["btn btn-sm btn-outline-info", {
                          approvedcomment: item.tenantcomments.approved,
                        }])
                            }, _hoisted_35, 10, _hoisted_33)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (toggleCommentsFlagged('Tenant', item)),
                              class: _normalizeClass(["btn btn-sm btn-outline-info text-danger", {
                          flaggedcomment: item.tenantcomments.flagged,
                        }])
                            }, _hoisted_38, 10, _hoisted_36)
                          ])
                        ]),
                        (item.tenantcomments.photos.length)
                          ? (_openBlock(), _createElementBlock("tr", {
                              key: item._uuid
                            }, [
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("table", _hoisted_42, [
                                      (_openBlock(), _createBlock(Photos, {
                                        key: getCommentsPhotosLength('Tenant', item),
                                        photos: getCommentsPhotos('Tenant', item),
                                        path: getCommentsPhotoPath('Tenant', item)
                                      }, null, 8, ["photos", "path"]))
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: statereport.value.landlordcommentsname,
                disabled: ""
              }, null, 8, _hoisted_49)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: statereport.value.landlordcommentsemail,
                disabled: ""
              }, null, 8, _hoisted_53)
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "10",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((client).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  client.value,
                  void 0,
                  { lazy: true }
                ]
              ]),
              (_openBlock(), _createBlock(Photos, {
                photos: clientPhotos.value,
                path: 'comments.clientPhotos',
                key: `${clientPhotos.value.length}`
              }, null, 8, ["photos", "path"]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          (commentedItemsByLandlord.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createElementVNode("table", _hoisted_59, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63,
                      _hoisted_64,
                      _createElementVNode("th", _hoisted_65, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleAllCommentsApproved('Landlord'))),
                          class: _normalizeClass(["btn btn-sm btn-outline-info", {
                        approvedcomment: allllcommentsapproved.value,
                      }])
                        }, _hoisted_67, 2)
                      ]),
                      _createElementVNode("th", _hoisted_68, [
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleAllCommentsFlagged('Landlord'))),
                          class: _normalizeClass(["btn btn-sm btn-outline-info text-danger", {
                        flaggedcomment: allllcommentsflagged.value,
                      }])
                        }, _hoisted_70, 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentedItemsByLandlord.value, (item) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.uuid
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_71, _toDisplayString(item.order), 1),
                          _createElementVNode("td", null, _toDisplayString(item.roomname), 1),
                          _createElementVNode("td", null, _toDisplayString(item.section) + ":" + _toDisplayString(item.type) + ":" + _toDisplayString(item.name), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("table", _hoisted_72, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getConditionInNotes(item), (note) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: note._uuid
                                }, [
                                  _createElementVNode("td", _hoisted_73, _toDisplayString(note.note), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(ContentEditable, {
                              content: item.landlordcomments.comments,
                              multiline: true,
                              onUpdate: ($event: any) => (
                          setReportDeep({
                            path: getItemPath(
                              item,
                              'landlordcomments.comments'
                            ),
                            data: $event,
                          })
                        )
                            }, null, 8, ["content", "onUpdate"])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (toggleCommentsApproved('Landlord', item)),
                              class: _normalizeClass(["btn btn-sm btn-outline-info", {
                          approvedcomment: item.landlordcomments.approved,
                        }])
                            }, _hoisted_76, 10, _hoisted_74)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (toggleCommentsFlagged('Landlord', item)),
                              class: _normalizeClass(["btn btn-sm btn-outline-info text-danger", {
                          flaggedcomment: item.landlordcomments.flagged,
                        }])
                            }, _hoisted_79, 10, _hoisted_77)
                          ])
                        ]),
                        (item.landlordcomments.photos.length)
                          ? (_openBlock(), _createElementBlock("tr", {
                              key: item._uuid
                            }, [
                              _createElementVNode("td", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _createElementVNode("table", _hoisted_83, [
                                      (_openBlock(), _createBlock(Photos, {
                                        key: getCommentsPhotosLength('Landlord', item),
                                        photos: getCommentsPhotos('Landlord', item),
                                        path: getCommentsPhotoPath('Landlord', item)
                                      }, null, 8, ["photos", "path"]))
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "hidden",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((propertyInspector).value = $event))
      }, null, 512), [
        [_vModelText, propertyInspector.value]
      ])
    ])
  ]))
}
}

})